module.exports = __webpack_public_path__ + "img/5.abea43a0.png";